import { trackEvent } from '~/adapters/tracking/tracking';
import { AnalyticsConstants } from '~/adapters/tracking/AnalyticsConstants';

export function sendSharedDesignEvent(action: string, label: string, cardIndex: number) {
    const category = 'Account Shared Designs';
    trackEvent({ category, action, label, dimension: { [AnalyticsConstants.cardIndex]: cardIndex } });
}
